export const RadnoVrijemeSumEvdResourceEN: RadnoVrijemeSumEvdInterface = {
  title: "Working Time List",
  errors: {
    query:
      "An error occurred while loading users. Please contact the administrator.",
  },
  inputFields: {
    branch: {
      placeholder: "Select branch",
      notFound: "No branch found",
    },
    endDate: {
      label: "End date",
    },
    startDate: {
      label: "Start date",
    },
    user: {
      error: "Please select user",
      label: "Select user",
      name: "user",
      placeholder: "Select user",
    },
  },
  pdf: {
    button: "Download PDF",
    document: {
      name: "First and last name",
      title: "Working time evidence",
      odabraniPeriod: "Selected period",
      ukupnoVrijeme: "Total hours",
      potpisFooter: "Signature",
      upisaoFooter: "Approved by",
      entryType: "Evidence type",
      napomena: "Note",
      pocetak: "Start",
      pocetakPauze: "Break start",
      potpisano: "Signature",
      zavrsetak: "End",
      zavrsetakPauze: "Break end",
      tipovi: {
        DEZURA: "On-call duty",
        ODSUSTVO: "Absence",
        PRIPRAVNOST: "Standby",
        RADNOVRIJEME: "Working time",
        RADUSMJENAMA: "Shift work",
        TERENSKIRAD: "Field work",
        BOLOVANJE: "Sick leave",
        SLOBODANDAN: "Day off",
      },
    },
  },
  sihtarica: {
    periodLabel: "Period (month)",
    statusOpen: "Open",
    statusLocked: "Locked",
    statusApproved: "Approved",
    lock: "Approve / Lock",
    approveSelected: "Approve selected",
    approveNoneSelected: "Select at least one entry to approve.",
    approvedOk: "Selected entries have been approved.",
    unapprove: "Unapprove",
    unapproveOk: "Approval has been revoked.",
    reopen: "Reopen",
    viewByWorker: "By workers",
    viewByDay: "By days",
    batchEdit: "Batch edit",
    edit: "Edit",
    delete: "Delete",
    deleteConfirm: "Are you sure you want to delete this entry?",
    deleteOk: "Entry deleted.",
    addEntry: "Add entry",
    addEntryTitle: "Add working time",
    save: "Save",
    cancel: "Cancel",
    editReason: "Change reason",
    editReasonRequired: "Change reason is required.",
    pdfOnlyLocked: "PDF can be downloaded only after the period is locked.",
    lockedOk: "Period locked.",
    reopenedOk: "Period reopened.",
    editOk: "Change saved.",
    addOk: "Entry added.",
    batchOk: "Batch change saved.",
    actionError: "Action failed.",
    errorDuplicateEntry:
      "An entry with the same type and times already exists for this day. Change the type or the schedule.",
    empty: "No records for the selected period.",
    totalHours: "Total",
    deviation: "Exceedance",
    colDate: "Date",
    colWorker: "Worker",
    colType: "Type",
    colIn: "Clock in",
    colOut: "Clock out",
    colHours: "Hours",
    colNote: "Note",
  },
};

interface InputFieldInterface {
  label: string;
  name: string;
  placeholder: string;
  error: string;
}

export interface RadnoVrijemePDFSumInterface {
  name: string;
  title: string;
  odabraniPeriod: string;
  potpisFooter: string;
  upisaoFooter: string;
  entryType: string;
  pocetak: string;
  zavrsetak: string;
  pocetakPauze: string;
  zavrsetakPauze: string;
  napomena: string;
  potpisano: string;
  ukupnoVrijeme: string;
  tipovi: {
    RADNOVRIJEME: string;
    RADUSMJENAMA: string;
    TERENSKIRAD: string;
    DEZURA: string;
    PRIPRAVNOST: string;
    ODSUSTVO: string;
    BOLOVANJE: string;
    SLOBODANDAN: string;
  };
}

export interface RadnoVrijemeSumEvdInterface {
  title: string;
  errors: {
    query: string;
  };
  inputFields: {
    branch: {
      placeholder: string;
      notFound: string;
    };
    startDate: {
      label: string;
    };
    endDate: {
      label: string;
    };
    user: InputFieldInterface;
  };
  pdf: {
    button: string;
    document: RadnoVrijemePDFSumInterface;
  };
  sihtarica: {
    periodLabel: string;
    statusOpen: string;
    statusLocked: string;
    statusApproved: string;
    lock: string;
    approveSelected: string;
    approveNoneSelected: string;
    approvedOk: string;
    unapprove: string;
    unapproveOk: string;
    reopen: string;
    viewByWorker: string;
    viewByDay: string;
    batchEdit: string;
    edit: string;
    delete: string;
    deleteConfirm: string;
    deleteOk: string;
    addEntry: string;
    addEntryTitle: string;
    save: string;
    cancel: string;
    editReason: string;
    editReasonRequired: string;
    pdfOnlyLocked: string;
    lockedOk: string;
    reopenedOk: string;
    editOk: string;
    addOk: string;
    batchOk: string;
    actionError: string;
    errorDuplicateEntry: string;
    empty: string;
    totalHours: string;
    deviation: string;
    colDate: string;
    colWorker: string;
    colType: string;
    colIn: string;
    colOut: string;
    colHours: string;
    colNote: string;
  };
}
